var _style, _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SvgjsSvg1000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "35px",
    height: "35px",
    viewBox: "0 0 144 102.4",
    style: {
      enableBackground: "new 0 0 144 102.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#231F20;stroke-width:3;stroke-miterlimit:10;}\n\t.st1{fill:#231F20;stroke:#231F20;stroke-width:3;stroke-miterlimit:10;}\n\t.st2{fill:#ED1F24;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 50.2,
    cy: 53.1,
    r: 45.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.1,28.3c5.3,6,8.8,13.8,9.3,22.4c0,0.1,0,0,0,0c-1.9,8.5-4.8,18.4-9.1,27.7c0,0-5.3,0.2-14.6,0.4 c-2.2-13.5-5.9-27.8-8.5-37.6h-0.1c-2.6,9.8-6.3,24.2-8.5,37.6C36.3,78.6,31,78.4,31,78.4C20.6,55.7,18.4,28.9,18.4,28.9 c4.8-0.3,8.8-0.5,12.9-0.6c1,10,4.5,29.9,6.5,35.6H38c1.8-11.9,4.9-24.3,9.8-36c4.7-0.1,7.9-0.2,12.7,0h0.2c4.9,11.7,8,24,9.8,36 h0.2C72.6,58.3,76.1,38.4,77.1,28.3L77.1,28.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.2,6.3c-1.6-0.2-3.3-0.3-5-0.3C24.2,6,3.1,27.1,3.1,53.1s21.1,47.1,47.1,47.1s47.1-21.1,47.1-47.1 C97.3,28.8,78.9,8.8,55.2,6.3l-0.4,3.9c21.7,2.3,38.5,20.6,38.5,42.9c0,23.8-19.3,43.1-43.1,43.1C26.4,96.3,7.1,77,7.1,53.1 S26.4,10,50.2,10c1.6,0,3.1,0.1,4.6,0.2L55.2,6.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M140.9,6.9c2.4,4.8,0.5,10.8-4.4,13.2l-27.3,13.7c-4.8,2.4-10.8,0.5-13.2-4.4c-2.4-4.8-0.5-10.8,4.4-13.2 l27.3-13.7C132.5,0.1,138.4,2.1,140.9,6.9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWgLogo);
export default __webpack_public_path__ + "static/media/wg-logo.86407eff93078cf9459370c7d81885ad.svg";
export { ForwardRef as ReactComponent };